module.exports = __webpack_public_path__ + "img/mealreminder-minip-white.d62554a4.png";